import styles from './styles.module.scss';


export default function CardEvento({evento,deletarEvento}) {
    return (
        <div className={styles.card}>
            <p>{evento.titulo}</p>
            <p>{evento.desc}</p>
            <button onClick={() => deletarEvento(evento.id)} className={styles.delete}>Deletar</button>
        </div>

    )

}